export interface MetricData {
  name: string;
  value: number;
  tags: Record<string, string>;
  timestamp: number;
}

export interface LogEntry {
  level: 'debug' | 'info' | 'warn' | 'error';
  message: string;
  context: Record<string, any>;
  timestamp: number;
}

export class MonitoringService {
  private static instance: MonitoringService;
  private metrics: MetricData[] = [];
  private logs: LogEntry[] = [];
  private flushInterval: NodeJS.Timeout;

  private constructor() {
    this.flushInterval = setInterval(() => this.flush(), 60000);
  }

  public static getInstance(): MonitoringService {
    if (!MonitoringService.instance) {
      MonitoringService.instance = new MonitoringService();
    }
    return MonitoringService.instance;
  }

  public recordMetric(name: string, value: number, tags: Record<string, string> = {}): void {
    this.metrics.push({
      name,
      value,
      tags,
      timestamp: Date.now()
    });
  }

  public log(level: LogEntry['level'], message: string, context: Record<string, any> = {}): void {
    this.logs.push({
      level,
      message,
      context,
      timestamp: Date.now()
    });

    // Also console log for development
    if (import.meta.env.DEV) {
      console[level](message, context);
    }
  }

  private async flush(): Promise<void> {
    if (this.metrics.length === 0 && this.logs.length === 0) return;

    try {
      // In a real implementation, send to monitoring service
      const payload = {
        metrics: this.metrics,
        logs: this.logs,
        timestamp: Date.now()
      };

      // Clear buffers after successful send
      this.metrics = [];
      this.logs = [];
    } catch (error) {
      console.error('Failed to flush monitoring data:', error);
    }
  }

  public destroy(): void {
    clearInterval(this.flushInterval);
  }
}